export default [
  {
    path: "/404",
    name: "noPage",
    hidden: true,
    component: () => import("@/views/err404/index.vue"),
    meta: {
      title: "404",
    },
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
];
